import React from "react";
import styled from "react-emotion";

export { default as styles, StylesProp } from "~lib/styles";

export { React, styled };
